import React, { memo } from "react";
import { Button, Stack } from "@mui/material";
import { FormHelperStyledError } from "./ui-utils";

const commonStyles = {
  borderRadius: "6px",
  color: "white",
  fontFamily: "proxima-nova, sans-serif",
  width: "90px",
  height: "44px",
  textTransform: "none",
  "&:active": {
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    border: "1px solid rgba(255, 255, 255, 0.7)",
  },
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    border: "transparent",
    fontWeight: "bold",
  },
};

const YesNoButtonsComponent = ({
  value,
  handleClick,
  values,
  isMobile = false,
}) => {
  const sx = isMobile ? { margin: "8px 0" } : {};
  const isYes = value === values[0];
  const isNo = value === values[1];
  return (
    <Stack direction="row" spacing={1} sx={sx}>
      <Button
        variant={isYes ? "contained" : "outlined"}
        onClick={() => handleClick(values[0])}
        sx={{
          ...commonStyles,
          border: isYes ? "none" : `1px solid rgba(255, 255, 255, 0.5)`,
          backgroundColor: isYes ? "rgba(255, 255, 255, 0.3)" : "transparent",
          fontWeight: isYes ? "bold" : "normal",
        }}
      >
        Yes
      </Button>
      <Button
        variant={isNo ? "contained" : "outlined"}
        onClick={() => handleClick(values[1])}
        sx={{
          ...commonStyles,
          border: isNo ? "none" : `1px solid rgba(255, 255, 255, 0.5)`,
          backgroundColor: isNo ? "rgba(255, 255, 255, 0.3)" : "transparent",
          fontWeight: isNo ? "bold" : "normal",
        }}
      >
        No
      </Button>
    </Stack>
  );
};

function arePropsEqual(prevProps, nextProps) {
  const {
    value: prevValue,
    handleClick: prevHandleClick,
    isMobile: prevIsMobile,
    error: prevError,
    helperText: prevHelperText,
  } = prevProps;
  const {
    value: nextValue,
    handleClick: nextHandleClick,
    isMobile: nextIsMobile,
    error: nextError,
    helperText: nextHelperText,
  } = nextProps;

  const isPrevHandleClickFalsey = !prevHandleClick;
  const isNextHandleClickFalsey = !nextHandleClick;

  const hasHandleClickChanged =
    isPrevHandleClickFalsey != isNextHandleClickFalsey;
  const hasValueChanged = prevValue !== nextValue;
  const hasIsMobileChanged = prevIsMobile !== nextIsMobile;
  const hadErrorChanged = prevError !== nextError;
  const hadHelperTextChanged = prevHelperText !== nextHelperText;

  return (
    !hasValueChanged &&
    !hasIsMobileChanged &&
    !hasHandleClickChanged &&
    !hadErrorChanged &&
    !hadHelperTextChanged
  );
}

export const YesNoButtons = memo(YesNoButtonsComponent, arePropsEqual);

const YesNoButtonsWithErrorComponent = ({
  value,
  handleClick,
  values,
  isMobile = false,
  error = false,
  helperText,
  className = "",
}) => {
  const errorContainerSx = isMobile ? { flex: 1 } : {};
  const buttonContainerSx = isMobile ? { margin: "8px 0" } : {};
  const isYes = value === values[0];
  const isNo = value === values[1];
  return (
    <Stack direction="column" sx={errorContainerSx} className={className}>
      <Stack direction="row" spacing={1} sx={buttonContainerSx}>
        <Button
          variant={isYes ? "contained" : "outlined"}
          onClick={() => handleClick(values[0])}
          sx={{
            ...commonStyles,
            border: isYes ? "none" : `1px solid rgba(255, 255, 255, 0.5)`,
            backgroundColor: isYes ? "rgba(255, 255, 255, 0.3)" : "transparent",
            fontWeight: isYes ? "bold" : "normal",
            flex: isMobile ? 1 : 0,
          }}
        >
          Yes
        </Button>
        <Button
          variant={isNo ? "contained" : "outlined"}
          onClick={() => handleClick(values[1])}
          sx={{
            ...commonStyles,
            border: isNo ? "none" : `1px solid rgba(255, 255, 255, 0.5)`,
            backgroundColor: isNo ? "rgba(255, 255, 255, 0.3)" : "transparent",
            fontWeight: isNo ? "bold" : "normal",
            flex: isMobile ? 1 : 0,
          }}
        >
          No
        </Button>
      </Stack>
      {error && helperText && (
        <FormHelperStyledError>{helperText}</FormHelperStyledError>
      )}
    </Stack>
  );
};

export const YesNoButtonsWithError = memo(
  YesNoButtonsWithErrorComponent,
  arePropsEqual
);
